var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0 mx-auto pt-0"},[_c('v-card',{staticClass:"elevation-12 mx-auto",attrs:{"max-width":"320"}},[_c('v-card-text',[_c('div',{staticClass:"text-subtitle-1 my-3 text-center"},[_vm._v(" You have successfully updated your preferences. ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }